import * as React from "react";
import dayjs from "dayjs";

import { Box, Grid } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { AUDIO_TRANSLATION_VALIDATION, IS_AUDIO_TRANSLATION_VALID } from "../../../../helper-functions/validation/translationValidation";

import { getLanguage } from "../../../../config/language/language";
import { AUDIO_TRANSLATION_OBJECT, VOICE_OPTIONS } from "../../../../config/constants/Constants";

/**
 * A form to update a audio translation.
 */
export default function AudioTranslationEditForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = AUDIO_TRANSLATION_OBJECT;
    const validation = AUDIO_TRANSLATION_VALIDATION;
    const isValid = IS_AUDIO_TRANSLATION_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            _voice: existingRow.meta_data?.voice ?? "alloy",
            _instructions: existingRow.meta_data?.instructions ?? "",

            // Convert to dayjs format if datetime exists.
            created_on: existingRow.created_on ? dayjs(existingRow.created_on) : null,
            updated_on: existingRow.updated_on ? dayjs(existingRow.updated_on) : null,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newRow = JSON.parse(JSON.stringify(row));
        setValue(newRow, key, value);

        if (key === "_voice") {
            newRow.meta_data.voice = value;
        }

        if (key === "_instructions") {
            newRow.meta_data.instructions = value;
        }

        validateRow(obj, validation, newRow);
        setInsertObjectState(setRow, newRow);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    return (
        <Box className="box">
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <CustomInput name="_voice" row={row} onChange={onChange} label="Voice" select={VOICE_OPTIONS} />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="_instructions" row={row} onChange={onChange} label="Instructions" multiline minRows={2} maxRows={10} />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Update audio translation"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
